import { useTheme } from "@emotion/react";
import React from "react";

type TimeFieldProps = {
  value: Date;
  onChange: (value: Date) => void;
  label?: string;
  className?: string;
  isDisabled?: boolean;
};

export const TimeField: React.FunctionComponent<TimeFieldProps> = ({
  value,
  onChange,
  label,
  className,
  isDisabled,
}) => {
  const theme = useTheme();

  const formatTime = (date: Date) => {
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    return `${hours}:${minutes}`;
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      const [hours, minutes] = e.target.value.split(":").map((num) => parseInt(num, 10));
      const selectedTime = new Date(value);
      selectedTime.setHours(hours);
      selectedTime.setMinutes(minutes);
      onChange(selectedTime);
    }
  };

  const timeInputProps = {
    value: formatTime(value),
    onChange: handleTimeChange,
    type: "time",
    css: {
      width: "100%",
      border: "none",
      padding: "0.5rem 0.75rem",
      fontSize: "1rem",
      borderRadius: "6px",
      cursor: "text",
      backgroundColor: theme.colors.primaryLight,
      ":focus": {
        outline: `1px solid ${theme.colors.primary}`,
      },
      input: {
        cursor: "pointer",
      },
      "input::-webkit-calendar-picker-indicator": {
        cursor: "pointer",
      },
    },
    disabled: isDisabled ? true : false,
  };

  return (
    <div css={{ display: "flex", flexDirection: "column" }} className={className}>
      {label && (
        <label
          css={{
            color: theme.colors.primary,
            fontSize: "0.875rem",
            fontFamily: theme.displayFontFamily,
            marginBottom: "0.25rem",
          }}
        >
          {label}
        </label>
      )}
      <input {...timeInputProps} />
    </div>
  );
};